<template>
  <div>
    <template
      v-if="tabName == 'system'"
    >
      <system-edit
        :position="position"
        :item="item"
        edit-class="edtior-system"
        :edit-option="systemOption"
        :hide="hide"
      />
    </template>
    <template
      v-else-if="tabName == 'wechat'"
    >
      <system-edit
        :position="position"
        :item="item"
        edit-class="edtior-wechat"
        :edit-option="wechatOption"
        :hide="hide"
      />
    </template>
    <template
      v-else-if="tabName == 'wexin'"
    >
      <system-edit
        :position="position"
        :item="item"
        edit-class="edtior-system"
        :edit-option="systemOption"
        :hide="hide"
      />
    </template>
    <template
      v-else-if="tabName == 'dingtalk'"
    >
      <system-edit
        :position="position"
        :item="item"
        edit-class="edtior-system"
        :edit-option="systemOption"
        :hide="hide"
      />
    </template>
    <template
      v-else-if="tabName == 'sms'"
    >
      <system-edit
        :position="position"
        :item="item"
        edit-class="edtior-system"
        :edit-option="systemOption"
        :hide="hide"
      >
        <!-- <p
          slot="sms-tip"
          class="msg-send-tip"
        >注意：因变量内容长度不固定，短信内容过长时，<br>
          将分条发送（70字/条）</p> -->
      </system-edit>
    </template>
    <template
      v-else-if="tabName == 'email'"
    >
      <system-edit
        :position="position"
        :item="item"
        edit-class="edtior-wechat email-editor"
        :edit-option="emailOption"
        :hide="hide"
      />
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SystemEdit from './SystemEdit'
export default {
  components: {
    SystemEdit
  },
  props: {
    position: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    hide: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      systemOption: {
        placeholder: '',
        modules: {
          toolbar: [ ]
        }
      },
      wechatOption: {
        placeholder: '',
        modules: {
          toolbar: [
            [{ 'color': [] }]
          ]
        }
      },
      emailOption: {
        placeholder: this.$t('message["74"]'),
        modules: {
          toolbar: [
            [{ 'font': [] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'color': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': [] }]
          ]
        }
      }
    }
  },
  computed: {
    ...mapState('config/notice', ['tabName'])
  },
  mounted () {
    // console.log('position: ', this.position)
  },
  methods: {
    resetForm () {
      this.$refs.systemItem.resetForm()
    }
  }
}
</script>
<style lang="scss" scoped>
  .msg-send-tip {
    margin-left: 82px;
    color: #b3b3b3;
    line-height: 16px;
    margin-top: -15px;
  }
</style>
